var component = require('../../../lib/js/component.js');
var Chart = require('chart.js');

function InteractiveLmpCalculator() {

	var _this;

	var MORTGAGE_TYPES = {
		FHA_30_YEAR_FIXED: 'fha 30 year fixed',
		CONVENTIONAL_30_YEAR_FIXED: 'conventional 30 year fixed',
		CONVENTIONAL_15_YEAR_FIXED: 'conventional 15 year fixed'
	};

	var mortgageTypeConfig = {};
    
    mortgageTypeConfig[MORTGAGE_TYPES.FHA_30_YEAR_FIXED] = {
	 minDownpayment: 3.5,
     miFactors: [
      { maxLoan: 726200, factor: 0.55 },
      { minLoan: 726201, factor: 0.75 }
     ]
    };
    
    mortgageTypeConfig[MORTGAGE_TYPES.CONVENTIONAL_30_YEAR_FIXED] = {
      minDownpayment: 3,
      miFactors: [
		{ min: 95.01, max: 97, factor: 0.43 },
		{ min: 90.01, max: 95, factor: 0.27 },
		{ min: 85.01, max: 90, factor: 0.19 },
		{ min: 80.01, max: 85, factor: 0.12 }
      ]
    };
    
    mortgageTypeConfig[MORTGAGE_TYPES.CONVENTIONAL_15_YEAR_FIXED] = {
      minDownpayment: 3,
      miFactors: [
		{ min: 95.01, max: 97, factor: 0.28 },
		{ min: 90.01, max: 95, factor: 0.19 },
		{ min: 85.01, max: 90, factor: 0.14 },
		{ min: 80.01, max: 85, factor: 0.09 }
      ]
    };
    

	this.initialize = function (element) {
        _this = this;
        this.main = this.$element;

        this.$InteractiveLmpCalculatorForm = this.main.find(".InteractiveLmpCalculator");
        this.$chartContainer = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__chart-container");
        this.$detailsContent = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__details-content");
		this.$legendsContainer = this.$detailsContent.find(".mortgage-legend"); 
        this.$mortgageDetailsContent = this.$InteractiveLmpCalculatorForm.find(".mortage-details .mortgage-details-disclosure");

        this.$collapseToggle = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__collapse-toggle");
        this.$detailsToggle = this.$InteractiveLmpCalculatorForm.find(".InteractiveLmpCalculator__details-toggle");

		this.$principalInterestTooltipBtn = this.$legendsContainer.find('#principleInterestLegend .TooltipBtn--popoverAccordion');
		this.$propertyTax = this.$legendsContainer.find('#propertyTaxLegend .amount');
		this.$mortgageInsurance = this.$legendsContainer.find('#mortgageInsuranceLegend .amount');
		this.APR;
		
		this.chartInstance = null;      
        var lastUpdatedField = '';

        
		var chartColorsData = _this.$chartContainer.data('chartcolors');
		var chartLabelsData = _this.$chartContainer.data('chartlabels');
		var mortgageChartColors = chartColorsData ? chartColorsData.split(',') : [];
		var mortgageChartLabels = chartLabelsData ? chartLabelsData.split(',') : [];
		this.$mortgageChartOptions = {
			values: [1261, 288, 100, 10],
			labels: mortgageChartLabels,
			colors: mortgageChartColors
		};
		
		// Form Elements
		var $salesPriceInput = $('#salesPriceInput');
		var $dollarsInput = $('#dollarPaymentInput');
		var $percentageInput = $('#percentagePaymentInput');
		var $interestRateInput = $('#interestRateInput');
		this.$mortgageTypeInput = $('#mortgageTypeInput');
		this.$seeResultBtn = $('#caculatorSubmit')
	
        // Functions to show / hide error message
        var showErrorMessage = function ($field, isDownPaymentField) {
            $field.closest('label').addClass('has-error');
			if(isDownPaymentField){
				$field.closest('.InteractiveLmpCalculator__down-payment').addClass('has-error');
			}
        };
        var clearErrorMessages = function ($field, isDownPaymentField) {
			$field.closest('label').removeClass('has-error');
			if(isDownPaymentField){
				$field.closest('.InteractiveLmpCalculator__down-payment').removeClass('has-error');
			}
        };

		var handleInputFields = function () {
			// Remove '%' from percentageInput and interestRateInput when user focuses on input
			$percentageInput.on('focus', function () {
				$percentageInput.val($percentageInput.val().replace("%", ""));
			});

			$interestRateInput.on('focus', function () {
				$interestRateInput.val($interestRateInput.val().replace("%", ""));
			});

			// input events 
			$salesPriceInput.on('input', function () {
				var salesPriceValue = cleanNumericInput($salesPriceInput.val()).replace(/^0+/, ""); // Remove leading zeros
				salesPriceValue = parseFloat(salesPriceValue);
			
				if (isNaN(salesPriceValue) || salesPriceValue === 0) {
					salesPriceValue = 0;
					return; // Stop further execution
				}

				if (lastUpdatedField === 'dollars') {
					var downPaymentPercentage = (parseFloat($dollarsInput.val()) / salesPriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%");
				} else if (lastUpdatedField === 'percentage') {
					var downPaymentAmount = (parseFloat($percentageInput.val().replace("%", "")) / 100) * salesPriceValue;
					$dollarsInput.val(downPaymentAmount.toFixed(0));
				}
			});
	
			$dollarsInput.on('input', function () {
				lastUpdatedField = 'dollars';
				var dollarValue = $dollarsInput.val();
				var salesPriceValue = parseFloat($salesPriceInput.val());
				var downpaymentValue = parseFloat(dollarValue);
		
				// Check if the dollar value has 5 characters before the decimal
				if (dollarValue.split('.')[0].length >= 5 && downpaymentValue && salesPriceValue > 0) {
					var downPaymentPercentage = (downpaymentValue / salesPriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%"); // Add %
				}
		
				validateDownpayment();
			});
	
			$percentageInput.on('input', function () {
				lastUpdatedField = 'percentage';
				var percentageValue = cleanNumericInput($percentageInput.val()); 
				var salesPriceValue = parseFloat($salesPriceInput.val());
				var downpaymentPercent = parseFloat(percentageValue);
		
				if (percentageValue.split('.')[0].length >= 1 && downpaymentPercent && salesPriceValue > 0) {
					var downPaymentAmount = (downpaymentPercent / 100) * salesPriceValue;
					$dollarsInput.val(downPaymentAmount.toFixed(0));
				}
				validateDownpayment()
			});
	

			// Blur events to sync values after focus is lost
			$dollarsInput.on('blur', function () {
				var salePriceValue = parseFloat($salesPriceInput.val());
				var downPaymentValue = parseFloat($dollarsInput.val());
				if (downPaymentValue && salePriceValue > 0) {
					var downPaymentPercentage = (downPaymentValue / salePriceValue) * 100;
					$percentageInput.val(Math.round(downPaymentPercentage * 10) / 10 + "%");
				}
			});
	
			$percentageInput.on('blur', function () {
				var percentageValue = cleanNumericInput($percentageInput.val());
				var salePriceValue = parseFloat($salesPriceInput.val());
				var downpaymentPercent = parseFloat($percentageInput.val());
				if (downpaymentPercent && salePriceValue > 0) {
					var downPaymentAmount = (downpaymentPercent / 100) * salePriceValue;
					$dollarsInput.val(downPaymentAmount.toFixed(0));
				}
				// Ensure % is re-added after calculation
				if (percentageValue !== "") {
					$percentageInput.val(percentageValue + "%");
				}
			});

			$interestRateInput.on('blur', function () {
				var interestRateValue = cleanNumericInput($interestRateInput.val());
				if (interestRateValue !== "") {
					 $interestRateInput.val(interestRateValue + "%"); 
				}
				validateInterestRate();
			});
		};

		// Validate Downpayment Fields (Dollars and Percentage)
		var validateDownpayment = function () {
			var mortgageType = (_this.$mortgageTypeInput.val() || "").trim().toLowerCase(); 
			var downpaymentPercentage = parseFloat(cleanNumericInput($percentageInput.val()));
 
			var minRequiredDownpayment = mortgageTypeConfig[mortgageType].minDownpayment || 3.5;
			var isValid = downpaymentPercentage >= minRequiredDownpayment && downpaymentPercentage <= 100;
		
			if (!isValid) {
				showErrorMessage($dollarsInput, true);
				showErrorMessage($percentageInput, true);
			} else {
				clearErrorMessages($dollarsInput, true);
				clearErrorMessages($percentageInput, true); 
			}
		};
	
		// Validate Sale Price
		var validateSalePrice = function () {
			var parsedPriceValue = parseInt(cleanNumericInput($salesPriceInput.val())); // Remove non-numeric characters

			if (parsedPriceValue < 100000 || parsedPriceValue > 9999999) {
				showErrorMessage($salesPriceInput);
			} else {
				clearErrorMessages($salesPriceInput);
			}

			if(parseInt($dollarsInput.val()) && parseInt(cleanNumericInput($percentageInput.val))){
				validateDownpayment();
			}
		};
	
		// Validate Interest Rate
		var validateInterestRate = function () {
			var interestRateValue = parseFloat(cleanNumericInput($interestRateInput.val()));
			

			if (interestRateValue < 0.001 || interestRateValue > 99.999) {
				showErrorMessage($interestRateInput);
			} else {
				clearErrorMessages($interestRateInput);
			}
		};

		// Slightly adjust modal scroll position on popover close to prevent visual glitches,
        // such as layout shift or unexpected jump due to scroll recalculation.
		this.$InteractiveLmpCalculatorForm.find('.TooltipBtn--popoverAccordion').on('hidden.bs.popover', function () {
			var $modal = $('#interactive-lmp-calculator-modal');
			var currentScroll = $modal.scrollTop();
			$modal.scrollTop(currentScroll - 1);
		});

		this.$seeResultBtn.on("click", function (){
			updateMortgageInsurance();
		})
	
		// Event listeners for validation on blur
		$('#dollarPaymentInput, #percentagePaymentInput').on('blur', validateDownpayment);
		$('#salesPriceInput').on('blur', validateSalePrice);

		$('#interactive-lmp-calculator-modal').on('show.bs.modal', this.handleShowLMPCalculator);
	
		// Initialize all handlers
		handleInputFields();
        renderPieChart();
		setupToggleDetails();
	}

	this.handleShowLMPCalculator = function (e) {
		var communityId = e.relatedTarget.dataset.communityId;
		var itemType = e.relatedTarget.dataset.itemType;
		var itemId = e.relatedTarget.dataset.itemId;

		if (communityId && itemType && itemId) {
			getItems(communityId, itemType, itemId);
		} else {
			return
		}
	}
	
	function getItems (communityId, itemType, itemId) {
		var apiUrl = itemType.toLowerCase() == "plan" ? '/api/plan/homeplans?communityId=' + communityId
														: '/api/plan/qmiplans?communityId=' + communityId;

		$.ajax({
			type: 'GET',
			context: this,
			// Uncomment for local testing
			//  url: 'https://cdk2.dev.pulte.com' + apiUrl,
		    url: apiUrl,
			success: function (response) {
				var apiItem = $(response).filter(function (index, item) {
					if (itemType.toLowerCase() == "qmi") {
						return item.inventoryHomeID == itemId;
					}
					return item.id == itemId;
				})[0];
				if (apiItem) setDefaultValues(apiItem);
			}
		});
	}

	function setDefaultValues (item) {
		if (item.mortgagePayment == null) {
			return;
		}

		var downPaymentDollars = Math.round((item.mortgagePayment.finalPrice * item.mortgagePayment.downPaymentPercentage) / 100);	// Round to whole number
		var downPaymentPercentage = (Math.round(item.mortgagePayment.downPaymentPercentage * 10) / 10).toLocaleString(undefined, {maximumFractionDigits:1});	// Round to 1 decimal place
		var interestRatePercent = (Math.round(item.mortgagePayment.interestRatePercent * 1000) / 1000).toLocaleString(undefined, {maximumFractionDigits:3});	// Round to 3 decimal places

		// Set the default values
		$('.InteractiveLmpCalculator__sale-price input').val(Math.round(item.mortgagePayment.finalPrice));	// Round to whole number
		$('.InteractiveLmpCalculator__dollars input').val(downPaymentDollars);
		$('.InteractiveLmpCalculator__percentage input').val(downPaymentPercentage + '%');
		$('.InteractiveLmpCalculator__interest-rate input').val(interestRatePercent + '%');
        _this.APR = item.mortgagePayment.apr

		updateMortgageInsurance()
		updateModalContent()
	}

	function renderPieChart() {

		var canvas = document.getElementById("mortgageChart"); // Get the canvas element
		if (!canvas) {
			console.error("Canvas element not found!");
			return;
		}
	
		var isExpanded = _this.$chartContainer.hasClass("expanded");
		var isMobileScreen = window.innerWidth <= 767
		
		if (isMobileScreen) {
			updateTooltipPlacementsForMobile();
		}
        // Set cutoutPercentage: 
		var cutoutSize = isExpanded ? 80 : (isMobileScreen ? 65 : 80);
		var chartData = {
			labels: _this.$mortgageChartOptions.labels,
			datasets: [
				{
					data: _this.$mortgageChartOptions.values,
					backgroundColor: _this.$mortgageChartOptions.colors
				}
			]
		};
	
		_this.chartInstance = new Chart(canvas.getContext("2d"), {
			type: "doughnut",
			data: chartData,
			options: {
				responsive: true,
				cutoutPercentage: cutoutSize,
				maintainAspectRatio: false,
				legend: {
                    display: false
                }
			}
		});
	}

	function setupToggleDetails() {
        _this.$detailsToggle.on("click", function () {
            _this.$chartContainer.addClass("expanded");
            _this.$detailsContent.slideDown();
            
            _this.$detailsToggle.hide();
            _this.$collapseToggle.show();

			 // Manually trigger chart resizing
			 renderPieChart();
			 _this.chartInstance.resize(); 
        });
    
        _this.$collapseToggle.on("click", function () {
            _this.$chartContainer.removeClass("expanded");
            _this.$detailsContent.slideUp();
    
            _this.$collapseToggle.hide();
            _this.$detailsToggle.show();

			 // Manually trigger chart resizing
			renderPieChart();
			_this.chartInstance.resize();
        });
    }

	function cleanNumericInput(value) {
		if(!value) return "0";
		var cleanedValue = value.replace(/[^0-9.]/g, ""); // Remove everything except numbers and .
		return cleanedValue.trim() === "" ? "0" : cleanedValue; // If empty, return "0"
    }
	
    function updateMortgageInsurance() {
        var salePrice = parseFloat($('.InteractiveLmpCalculator__sale-price input').val()) || 0;
        var downPayment = parseFloat($('.InteractiveLmpCalculator__dollars input').val()) || 0;
        var mortgageType = (_this.$mortgageTypeInput.val() || "").trim().toLowerCase(); 
        var insuranceElem = $("#mortgageInsuranceLegend .amount"); 
        var taglineElem = $("#mortgageInsuranceTagline");

        if (!salePrice || !mortgageType) return;

        var loan = salePrice - downPayment;
        var ltv = (loan / salePrice) * 100;
        var mi = 0;
		var factors = mortgageTypeConfig[mortgageType].miFactors;

        if (mortgageType === MORTGAGE_TYPES.CONVENTIONAL_30_YEAR_FIXED || mortgageType === MORTGAGE_TYPES.CONVENTIONAL_15_YEAR_FIXED) {
            for (var i = 0; i < factors.length; i++) {
                var range = factors[i];
                if (ltv > range.min && ltv <= range.max) {
                    mi = loan * range.factor;
                    break;
                }
            }

            if (taglineElem.length) {
                var depositPercent = (downPayment / salePrice) * 100;
                if (depositPercent >= 20) {
					taglineElem.addClass("show-tagline");
				} else {
					taglineElem.removeClass("show-tagline");
				}
            }
        } else if (mortgageType === MORTGAGE_TYPES.FHA_30_YEAR_FIXED) {
            if (loan <= factors[0].maxLoan) {
                mi = loan * factors[0].factor;
            } else {
                mi = loan * factors[1].factor;
            }
			taglineElem.removeClass("show-tagline"); // Hide tagline for FHA
        }

        if (insuranceElem.length) {
            insuranceElem.text("$" + mi.toFixed(0)); 
        }

		if (_this.$legendsContainer.length) {
			if (mi === 0) {
				_this.$legendsContainer.addClass("zero-mortgage-insuarance");
			} else {
				_this.$legendsContainer.removeClass("zero-mortgage-insuarance");
			}
		}
    }

	function updateModalContent() {
		var originalTooltipContent = _this.$principalInterestTooltipBtn.attr('data-content');
		var originalMortgageDetailsContent = _this.$mortgageDetailsContent.text();

		if (!originalTooltipContent || !originalMortgageDetailsContent) {
			return;
		}
	
		var updatedTooltipContent = replaceDynamicMortgageValues(originalTooltipContent);
		var updatedMortgageDetailsContent = replaceDynamicMortgageValues(originalMortgageDetailsContent);

		_this.$principalInterestTooltipBtn.attr('data-content', updatedTooltipContent);
		_this.$mortgageDetailsContent.text(updatedMortgageDetailsContent);
	}
	
	function replaceDynamicMortgageValues(originalContent) {
        var propertyTax = _this.$propertyTax.text() || "";
        var mortgageInsurance = _this.$mortgageInsurance.text() || "";
        var mortgageType = _this.$mortgageTypeInput.val() || "";
        var salePrice = $('.InteractiveLmpCalculator__sale-price input').val().replace(/[^\d]/g, '');
        var downPaymentDollars = $('.InteractiveLmpCalculator__dollars input').val().replace(/[^\d]/g, '');
        var downPaymentPercent = $('.InteractiveLmpCalculator__percentage input').val().replace('%', '');
        var interestRate = $('.InteractiveLmpCalculator__interest-rate input').val().replace('%', '');
        var loanAmount = Math.round(parseFloat(salePrice) - parseFloat(downPaymentDollars)).toLocaleString();

        return originalContent
            .replace(/\{property tax\}/g, propertyTax)
            .replace(/\{mortgage insurance\}/g, mortgageInsurance)
            .replace(/\{mortgage type\}/g, mortgageType)
            .replace(/\{sale price\}/g, Number(salePrice).toLocaleString())
            .replace(/\{loan amount\}/g, loanAmount)
            .replace(/\{down payment\}/g, downPaymentPercent)
            .replace(/\{interest rate\}/g, interestRate)
            .replace(/\{APR\}/g, _this.APR);
	}

	function updateTooltipPlacementsForMobile() {
		_this.$legendsContainer.find('li .TooltipBtn--popoverAccordion')
		.attr('data-placement', 'bottom');
	}
}

module.exports = component(InteractiveLmpCalculator);
